import { IEscolaridade } from "./IEscolaridade"
import { IGeolocalizacao } from "./IGeoLocalizacao"
import { IOcupacao } from "./IOcupacao"

export interface ILocalizacao {
    macrorregiao?: string
    mesorregiao?: string
    microrregiao?: string
    cidade?: string
    uf?: string
    cep?: string
    bairro?: string
    logradouro?: string
    categoria?: string
    value?: string
    estado?: string
}

export type ISexo = 'MASCULINO' | 'FEMININO'
export const SexoKeys: ISexo[] = ['MASCULINO', 'FEMININO']

export interface IAge {
    min?: number
    max?: number
}

export interface IDataNascimentoFilter {
    min?: Date
    max?: Date
}

export interface IRenda {
    min?: number
    max?: number
}

export type IClasseSocial = 'A' | 'B' | 'C' | 'D' | 'E'
export const ClasseSocialKeys: IClasseSocial[] = ['A', 'B', 'C', 'D', 'E']

export type IScoreVeles = 'ALTISSIMO RISCO' | 'ALTO RISCO' | 'MEDIO RISCO' | 'BAIXISSIMO RISCO' | 'BAIXO RISCO'
export const ScoreVelesKeys: IScoreVeles[] = [
    'ALTISSIMO RISCO',
    'ALTO RISCO',
    'MEDIO RISCO',
    'BAIXISSIMO RISCO',
    'BAIXO RISCO'
]


export type IContato = 'TELEFONECELULAR' | 'TELEFONEFIXO' | 'WHATSAPP' | 'EMAIL' | 'ENDERECO'
export const ContatoKeys: IContato[] = ["TELEFONECELULAR", "EMAIL", "TELEFONEFIXO", "ENDERECO", "WHATSAPP"]

export type IEstadoCivil =
    'CASADO' |
    'DIVORCIADO' |
    'VIUVO' |
    'SOLTEIRO' |
    'UNIAO ESTAVEL' |
    'OUTROS'

export const EstadoCivilKeys: IEstadoCivil[] = ["CASADO", "DIVORCIADO", "SOLTEIRO", "UNIAO ESTAVEL", "VIUVO", "OUTROS"]

export interface IFiltrosProjeto {
    localizacao?: ILocalizacao[]
    purgeLocalizacao?: ILocalizacao[]
    listasCEP?: number[]
    purgeListasCEP?: number[]
    listasDeduplicacao?: number[]
    geolocalizacao?: {
        data: IGeolocalizacao
        radius: number
    }
    sexo?: ISexo[]
    idade?: IAge
    dataNascimento?: IDataNascimentoFilter
    rendaPresumidaMensal?: IRenda
    rendaPresumidaAnual?: IRenda
    classeSocial?: IClasseSocial[]
    escolaridade?: IEscolaridade[]
    scoreVeles?: IScoreVeles[]
    cbo?: IOcupacao[]
    profissao?: IOcupacao[]
    contato?: IContato[]
    estadoCivil?: IEstadoCivil[]
}